export default {
  title: 'Metody zamówień',
  paywall: {
    live_title: '{{name}} jest już aktywna!',
  },
  tabs: {
    general: 'Ogólne',
    pickup: 'Odbiór osobisty',
    delivery: 'Dostawa',
    room_service: 'Obsługa pokoju/stolika',
  },
  modals: {
    update_confirmation: {
      title: 'Czy na pewno chcesz zapisać nowe zmiany?',
      buttons: {
        confirm: 'Potwierdź',
        cancel: 'Anuluj',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Czy na pewno chcesz wyłączyć zamówienia na żywo?',
        enable: 'Czy na pewno chcesz włączyć zamówienia na żywo?',
      },
      buttons: {
        yes: 'Tak',
        no: 'Nie',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
